export const PROMPT_LIBRARY = {
  PAGE: 'prompt-library-page',
  MODAL: 'prompt-library-modal',
  MODAL_BACK_BTN: 'prompt-library-modal-back-button',
  MODAL_CLOSE_BTN: 'prompt-library-modal-close-button',
  SEARCH_INPUT: 'prompt-library-search-input',
  CREATE_BUTTON: 'prompt-library-create-button',
  EMPTY_CREATE_BUTTON: 'prompt-library-empty-create-button',
  FILTER_BUTTON: 'prompt-library-filter-button',
  FILTER_SCOPE_ALL: 'prompt-library-filter-scope-all',
  FILTER_SCOPE_PERSONAL: 'prompt-library-filter-scope-personal',
  FILTER_CATEGORY_ITEM: 'prompt-library-filter-category',
  MANAGE_CATEGORIES_BTN: 'prompt-library-manage-categories-button',
  PROMPT_CARD: 'prompt-library-prompt-card',
  PROMPT_CARD_HIGHLIGHT: 'prompt-library-prompt-card-highlight',
  CARD_KEBAB_BTN: 'prompt-library-card-kebab-button',
  CARD_KEBAB_EDIT: 'prompt-library-card-kebab-edit',
  CARD_KEBAB_DELETE: 'prompt-library-card-kebab-delete',
  CARD_VIEW_BTN: 'prompt-library-card-view-button',
  CARD_PIN_BTN: 'prompt-library-card-pin-button',
  CARD_RUN_BTN: 'prompt-library-card-run-button',
  PERSONAL_BADGE: 'prompt-library-card-personal-badge',
  VIEW_DIALOG: 'prompt-library-view-dialog',
  VIEW_HEADER: 'prompt-library-view-header',
  VIEW_BODY: 'prompt-library-view-body',
  VIEW_CONTENT: 'prompt-library-view-content',
  VIEW_FOOTER: 'prompt-library-view-footer',
  VIEW_FOOTER_LEFT: 'prompt-library-view-footer-left',
  VIEW_FOOTER_ACTIONS: 'prompt-library-view-footer-actions',
  VIEW_COPY_BTN: 'prompt-library-view-copy-button',
  VIEW_EDIT_BTN: 'prompt-library-view-edit-button',
  VIEW_DELETE_BTN: 'prompt-library-view-delete-button',
  FORM_DIALOG: 'prompt-library-form-dialog',
  FORM_NAME_INPUT: 'prompt-library-form-name-input',
  FORM_NAME_CHAR_COUNTER: 'prompt-library-form-name-char-counter',
  FORM_DESC_INPUT: 'prompt-library-form-desc-input',
  FORM_DESC_CHAR_COUNTER: 'prompt-library-form-desc-char-counter',
  FORM_CATEGORY_SELECT: 'prompt-library-form-category-select',
  FORM_PROMPT_TEXTAREA: 'prompt-library-form-prompt-textarea',
  FORM_PROMPT_CHAR_COUNTER: 'prompt-library-form-prompt-char-counter',
  FORM_SAVE_BTN: 'prompt-library-form-save-button',
  FORM_CANCEL_BTN: 'prompt-library-form-cancel-button',
  FORM_DELETE_BTN: 'prompt-library-form-delete-button',
  DELETE_MODAL: 'prompt-library-delete-modal',
  DELETE_CONFIRM_BTN: 'prompt-library-delete-confirm-button',
  DELETE_CANCEL_BTN: 'prompt-library-delete-cancel-button',
  DISCARD_MODAL: 'prompt-library-discard-modal',
  DISCARD_CONFIRM_BTN: 'prompt-library-discard-confirm-button',
  DISCARD_CANCEL_BTN: 'prompt-library-discard-cancel-button',
  CREATE_CATEGORY_PANEL: 'prompt-library-create-category-panel',
  CREATE_CATEGORY_INPUT: 'prompt-library-create-category-input',
  CREATE_CATEGORY_SAVE_BTN: 'prompt-library-create-category-save-button',
  MANAGE_DISCARD_MODAL: 'prompt-library-manage-discard-modal',
  MANAGE_DISCARD_CONFIRM_BTN: 'prompt-library-manage-discard-confirm-button',
  MANAGE_DISCARD_CANCEL_BTN: 'prompt-library-manage-discard-cancel-button'
} as const;
